import type { ParticipateProductSurveyDto } from 'washday-sdk';
import WashdayClientSingleton from './WashdayClientSingleton';

export const getActiveProductSurvey = (token: string, signal?: AbortSignal) => {
  const client = WashdayClientSingleton.getInstance();
  if (client.apiToken !== token) throw new Error('Session changed');
  return client.productSurveys.getActive({ signal });
};
export const participateProductSurvey = (surveyId: string, dto: ParticipateProductSurveyDto, token: string) => {
  const client = WashdayClientSingleton.getInstance();
  if (client.apiToken !== token) throw new Error('Session changed');
  return client.productSurveys.participate(surveyId, dto);
};
